import { Typography } from '@material-ui/core';
import React from 'react';

const Pay = () => {
    return (
        <div>
            <Typography variant="h4" gutterBottom>
                Payment System Coming Soon.
            </Typography>
        </div>
    );
};

export default Pay;